import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const parseDate = (dateString, format = 'DD.MM.YYYY') => {
  if (!dateString) return '';

  const date = new Date(dateString);
  if (isNaN(date)) return '';

  const pad = (n) => String(n).padStart(2, '0');

  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1); // Monate sind 0-indexiert
  const year = date.getFullYear();

  if (format === 'DD.MM.YYYY') {
    return `${day}.${month}.${year}`;
  }
	else if(format === 'DD.MMMM.YYYY') {
		return new Intl.DateTimeFormat('de-DE', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(date);
	}
	else if(format === 'YYYY-MM-DD') {
		return `${year}-${month}-${day}`;
	}

  // other date format mappings here...

  return date.toLocaleDateString('de-DE');
};

const parseTime = (dateString, format = 'HH:mm') => {
  if (!dateString) return '';

  const date = new Date(dateString);
  if (isNaN(date)) return '';

  const pad = (n) => String(n).padStart(2, '0');

  if (format === 'HH:mm') {
    return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
  }

  // other date format mappings here...


  return date.toLocaleTimeString('de-DE', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
};

function getWeekStart(date = new Date()) {
  const day = date.getDay(); // 0 (So) bis 6 (Sa)
  const diff = day === 0 ? -6 : 1 - day; // Montag = 1, Sonntag = 0
  const monday = new Date(date);
  monday.setDate(date.getDate() + diff);
  monday.setHours(0, 0, 0, 0); // Uhrzeit auf Tagesbeginn setzen
  return monday;
}



function getISOWeekStart(date = new Date()) {
  const day = date.getDay(); // 0 (So) bis 6 (Sa)
  const diff = (day === 0 ? - 6 : 1 - day); // Montag = 1, Sonntag = 0
  const monday = new Date(date);
  monday.setDate(date.getDate() + diff);
  return monday.toISOString().split('T')[0]; // Nur das Datum (YYYY-MM-DD)
}

function getWeekEnd(date = new Date()) {
  const day = date.getDay(); // 0 (So) bis 6 (Sa)
  const diff = day === 0 ? 0 : 7 - day; // Sonntag = 0
  const sunday = new Date(date);
  sunday.setDate(date.getDate() + diff);
  sunday.setHours(23, 59, 59, 999); // Uhrzeit auf Tagesende setzen
  return sunday;
}


function getISOWeekEnd(date = new Date()) {
  const day = date.getDay(); // 0 (So) bis 6 (Sa)
  const diff = (day === 0 ? 0 : 7 - day); // Sonntag = 0, sonst bis Sonntag vorrechnen
  const sunday = new Date(date);
  sunday.setDate(date.getDate() + diff);
  return sunday.toISOString().split('T')[0]; // "YYYY-MM-DD"
}

function isToday(dateToCheck) {
  const now = new Date();
  const d = new Date(dateToCheck);
  return d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth() && d.getDate() === now.getDate();
}


const isBefore = (a, b) => new Date(a).getTime() < new Date(b).getTime();
const isAfter = (a, b) => new Date(a).getTime() > new Date(b).getTime();


export { getWeekEnd, getISOWeekEnd, getWeekStart, getISOWeekStart, isToday, parseDate, parseTime, isBefore, isAfter };

